import { render, staticRenderFns } from "./publicNoteManage.vue?vue&type=template&id=b6b7b1cc&scoped=true&"
import script from "./publicNoteManage.vue?vue&type=script&lang=js&"
export * from "./publicNoteManage.vue?vue&type=script&lang=js&"
import style0 from "./publicNoteManage.vue?vue&type=style&index=0&id=b6b7b1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7b1cc",
  null
  
)

export default component.exports